import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ExpenseStatementPage } from '@/features/zonalStatement/pages/ExpenseStatementPage';
import { zonalStatementSearchSchema } from '@/features/zonalStatement/types/zonalStatement.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/dashboards/zonal-statement/$userId/expense')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: zonalStatementSearchSchema,
  component: function ExpenseStatementRoute() {
    const { userId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Expense Statement">
        <Suspense fallback={<PageLoader />}>
          <ExpenseStatementPage userId={userId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
